const CardTitle = ({ children, ...rest }) => {
    return (
        <div className="card-title" {...rest}>
            {children}
        </div>
    );
};

export default CardTitle;
